import Swal from "sweetalert2"

export const popUpError = ({ title }) => {
    Swal.fire({
        title,
        icon: "error",
        timer: 1500,
        showConfirmButton: false
    })
}